import React, { createContext } from 'react'

export const UIContext = createContext({
    mode: localStorage.getItem('uiMode') || 'Logistics',
})
